import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';

const EditableValue = ({ field, currentValue, lotId, onSaved }) => {
  const { t }       = useTranslation();
  const [editing,   setEditing]   = useState(false);
  const [draft,     setDraft]     = useState(currentValue ?? '');

  const save = () => {
    setEditing(false);
    const trimmed = String(draft).trim();
    if (trimmed === String(currentValue ?? '')) return;
    const parsed = trimmed === '' ? null : (isNaN(Number(trimmed)) ? trimmed : Number(trimmed));
    Fetch('api/data/lots', 'PATCH',
      JSON.stringify({ _id: lotId, [`custom.${field.db_key}`]: parsed }),
      () => onSaved(field.db_key, parsed),
      () => {}
    );
  };

  if (editing) {
    return (
      <input
        className="wld-name-input"
        value={draft}
        style={{ width: 120, fontSize: 14 }}
        onChange={e => setDraft(e.target.value)}
        onBlur={save}
        onKeyDown={e => e.key === 'Enter' && save()}
        autoFocus
      />
    );
  }

  const display = currentValue != null ? String(currentValue) : t('lot_custom_field_value_empty');
  return (
    <span
      style={{ cursor: 'pointer', color: currentValue != null ? 'inherit' : '#aaa' }}
      onClick={() => { setDraft(currentValue ?? ''); setEditing(true); }}
    >
      {display}
      <span className="wld-edit-hint"> ✎</span>
    </span>
  );
};

const LotCustomFields = ({ lot }) => {
  const { t } = useTranslation();
  const [fields,       setFields]       = useState([]);
  const [customValues, setCustomValues] = useState(lot.custom || {});

  useEffect(() => {
    Fetch('api/data/lots.custom_fields', 'get', null, (data) => setFields(data || []));
  }, []);

  useEffect(() => {
    setCustomValues(lot.custom || {});
  }, [lot.custom]);

  if (fields.length === 0) return null;

  const handleSaved = (dbKey, value) => {
    setCustomValues(prev => ({ ...prev, [dbKey]: value }));
  };

  return (
    <div style={{ padding: '16px 0 0' }}>
      <div className="wl-stat-label" style={{ marginBottom: 8, fontWeight: 600, color: '#555' }}>
        {t('lot_custom_fields')}
      </div>
      <div className="wl-stats-grid">
        {fields.map(field => (
          <div key={field._id || field.db_key} className="wl-stat-card">
            <div className="wl-stat-label">{field.friendly_name}</div>
            <div className="wl-stat-value">
              <EditableValue
                field={field}
                currentValue={customValues[field.db_key] ?? null}
                lotId={lot._id}
                onSaved={handleSaved}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LotCustomFields;
